import React from "react";
import DatePicker from "sassy-datepicker";

const Example = (props) => {
    const onChange = (date) => {
        props.handleDatePicker(date.toString());
    };
    return (
        <>
            <DatePicker onChange={onChange} />
        </>
    );
}

export default Example;
